import { CanDeactivateFn } from "@angular/router";
import { CanComponentDeactivate } from "./interfaces/canDeactivate/can-deactivate.interface";

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component: CanComponentDeactivate) => {
  return component?.canDeactivate ? component.canDeactivate() : true;
};